module.exports = __webpack_public_path__ + "img/PL08063.9118618b.png";